<template>
  <div class="appList">
    <!-- CIP SELECTION -->
    <nav class="navbar navbar-inverse cipSelection">
      <div class="container-fluid cipInfos">
        <select v-model="cipID" id="" class="cipDropdown" @change="changeRoute">
          <option value="0" disabled selected style="display: none">
            ---- Please Choose ----
          </option>
          <option
            :value="cip.cipID"
            v-for="cip in filteredCipList"
            :key="cip.cipID"
          >
            {{ cip.cipID }} - {{ cip.cipName }}
          </option>
        </select>

        <div class="btn-group cipSearch">
          <input
            type="text"
            class="form-control"
            placeholder="Search Project by name"
            v-model="filterText"
          />
        </div>

        <div class="exportProject">
          <button
            class="btn btn-primary"
            title="Export Image Assets codebook"
            @click="ExportProjectInfo"
          >
            Export Implicit Projects
          </button>
        </div>
      </div>
    </nav>

    <!-- CIP WISE FUNCTION -->
    <nav class="navbar navbar-default cipFunction" v-show="cipID">
      <div class="container-fluid">
        <!-- buttons on left -->
        <div class="navbar-left navbar-form">
          <router-link
            activeClass="active"
            tag="a"
            :to="{
              name: 'pgnatConfig',
              query: {
                projectID: 0,
                cipID: cipID,
              },
            }"
          >
            <button
              class="btn btn-primary"
              title="create PGNAT project"
              :disabled="cipID === '0'"
            >
              Add PGNAT
            </button>
          </router-link>

          <router-link
            activeClass="active"
            tag="a"
            :to="{
              name: 'gnatConfig',
              query: {
                projectID: 0,
                cipID: cipID,
              },
            }"
          >
            <button
              class="btn btn-primary"
              title="create GNAT project"
              :disabled="cipID === '0'"
            >
              Add GNAT
            </button>
          </router-link>

          <router-link
            activeClass="active"
            tag="a"
            :to="{
              name: 'aptConfig',
              query: {
                projectID: 0,
                cipID: cipID,
              },
            }"
          >
            <button
              class="btn btn-primary"
              title="create APT project"
              :disabled="cipID === '0'"
            >
              Add APT
            </button>
          </router-link>

          <!-- <button class="btn btn-primary" disabled="disabled" title="create Semantic project">
                        Add GNAT
                    </button> -->
        </div>

        <!-- data export option on right -->
        <div class="navbar-right dataExport">
          <a
            class="btn btn-primary"
            href="assets/zoneInformation.docx"
            target="_blank"
            title="Download original zone definition"
            >Zone Library</a
          >
          <button
            class="btn btn-primary"
            title="Export Image Assets codebook"
            :disabled="cipID === '0'"
            @click="exportRNMapping"
          >
            Asset Mapping Export
          </button>
        </div>
      </div>
    </nav>

    <appProjectList :cipID="cipID"></appProjectList>
   
  </div>
</template>

<script>
import ProjectList from "./projectLists/ProjectList.vue";
import * as utils from "../utils.js";

export default {
  components: {
    appProjectList: ProjectList,
  },
  watch: {
    cipID: function () {
      if (this.cipID !== "0") {
        this.filterText = "";
        if (!this.$route.query.cipID) {
        const curCip = this.cipList.find(
          (cip) => Number(cip.cipID) === this.cipID
        );
        this.cipName = curCip.cipName
        }
      }
    },
    $route(to, from) {
      var route = this.$route.query.cipID;
      if (route) {
        this.cipID = Number(route);
      }
    },
  },
  computed: {
    filteredCipList() {
      return this.cipList.filter((element) => {
        if (element.cipName.match(new RegExp(this.filterText, "i"))) {
          return element;
        }
      });
    }
  },
  data() {
    return {
      cipList: [],
      filterText: "",
      cipID: "0",
      email: "",
      wsHeader: "https://iat.hotspexeurope.com/service.asmx/",
    };
  },
  methods: {
    selectCIP(cipID, cipName) {
      // console.log('cipID: ' + cipID);
      // console.log('cipName: ' + cipName);

      this.filterText = "";
      this.cipID = cipID;

      // update project name in dropdown
      document.getElementsByClassName("cipSelected")[0].innerHTML =
        cipID + " - " + cipName;
    },
    ExportProjectInfo() {
      var appBlockElm = document.getElementById("appBlock");
      appBlockElm.classList.remove("hidden");
      this.$http
        .get(this.wsHeader + "ExportProjectInfo")
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          var link = data.result.replace("http://", "https://");
          window.open(link, "_blank");
          appBlockElm.classList.add("hidden");
        });
    },
    exportRNMapping() {
      var appBlockElm = document.getElementById("appBlock");
      appBlockElm.classList.remove("hidden");

      var data = JSON.stringify({ cipid: this.cipID, email: this.email });

      // SEND BRAND MAPPING EMAIL TO USER
      this.$http
        .post(this.wsHeader + "exportRNMapping", data)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            window.alert("Export will be sent to your email sonn");
            appBlockElm.classList.add("hidden");
          }
        });
    },
    getCIPList() {
      // GET CIP LIST
      this.$http
         .get("https://packspex.hotspexeurope.com/Px.asmx/" + 'GetCIPListUser?emailID='+ this.email)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            // console.log('data: ' + JSON.stringify(data));
            this.cipList = data;
            document.getElementById("appBlock").classList.add("hidden");
          }
        });
    },
    changeRoute() {
      this.$router.push({ path: "/?cipID=" + this.cipID });
    },
    async readCookieAsync() {
      return await utils.readCookie("HOTSPEXAWESOME");
    }
  },
  async created() {
    var appBlockElm = document.getElementById("appBlock");
    appBlockElm.classList.remove("hidden");

    var response = await this.readCookieAsync();

    if((response && response.success)) {
      let hsCookie = utils.queryStringToJSON(response.data);
      if (hsCookie) {
        this.email = hsCookie.email;
        this.getCIPList();
      } else {
        if (window.location.href.indexOf("http://localhost:8008") !== -1) {
          this.email = "devs@hotspexeurope.com";
          this.getCIPList();
        } else {
          alert(
            "Please log in https://awesome.hotspexeurope.com/ site first before continue"
          );
        }
      }
    } else {
      setTimeout(function () {
        alert(response.message)
        window.open('https://awesome.hotspexeurope.com/', '_self')
      })
    }
    var route = this.$route.query.cipID

    if (route){
        this.cipID = this.$route.query.cipID
     }
     this.$router.push({ path: "/?cipID=" + this.cipID });
  },
   beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.cipID = vm.$route.query.cipID ? vm.$route.query.cipID : 0
    })
  }
};
</script>

<style scoped>
.navbar {
  margin-bottom: 2px;
}

/*    .cipInfos
    {
        display: grid;
        grid-template-columns: 6fr 1fr 1fr;
    }*/

.cipDropdown {
  margin-top: 7px;
  width: 60%;
  height: 34px;
  border-radius: 4px;
  display: block;
  float: left;
  color: #333;
}
c .dropdownDefault {
  text-align: left;
  width: calc(100% - 30px);
}

.dropdown-menu {
  width: calc(100% - 30px);
  max-height: 400px;
  overflow-y: auto;
}

.cipSelection .dropdown-menu li {
  padding-left: 10px;
}

.cipSelection .cipSearch,
.cipSelection .exportProject {
  margin-top: 7px;
  margin-left: 5px;
  width: calc(20% - 5px);
  float: left;
}

.cipSelection .exportProject button {
  width: 100%;
}

.cipSelection input {
  width: 100%;
}

.cipFunction .navbar-form .btn {
  min-width: 120px;
}

.cipFunction .navbar-form {
  padding-left: 0;
}

.dataExport {
  margin: 8px 4px 0 0;
}

.dataExport .dropdownDefault {
  width: 150px;
}

.dataExport .dropdown-menu {
  width: 176px;
  padding: 5px;
}

.dataExport .dropdown-menu li a {
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// ProjectHome.vue?6dd3a7a4